import { cn } from '../../lib/cn';

export interface CountBadgeProps {
  children: number | string;
  /** `primary` nur für Ungelesenes, das Aufmerksamkeit braucht. */
  tone?: 'neutral' | 'primary';
  /** Über 99 als „99+“. In der Sidebar aus: Dort steht die volle Zahl. */
  cap?: boolean;
  className?: string;
}

/** Eine Zahl neben einem Label. Über 99 als „99+“, außer in der Sidebar. */
export function CountBadge({ children, tone = 'neutral', cap = true, className }: CountBadgeProps) {
  const text = cap && typeof children === 'number' && children > 99 ? '99+' : children;
  return (
    <span
      className={cn(
        'inline-flex h-5 min-w-5 items-center justify-center rounded-full px-1.5 font-mono text-[11px] font-medium leading-4 tabular',
        tone === 'primary' ? 'bg-primary text-primary-foreground' : 'bg-muted text-muted-foreground',
        className,
      )}
    >
      {text}
    </span>
  );
}
